import React, { useEffect,useState } from "react";
import TreeView from "@mui/lab/TreeView";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TreeItem from "@mui/lab/TreeItem";
//import { Checkbox, FormControlLabel } from "@mui/material";
import { RenderTree, data } from "./sampledata.ts";
import { makeStyles } from "@mui/styles";
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
  List,
  ListItem,
  Typography,
  Box
} from '@mui/material';
import { use } from "react";
import { set } from "date-fns";


const useStyles = makeStyles((theme) => ({
  checkbox: {
    "&.MuiCheckbox-root": {
      color: "rgba(81, 185, 201, 0.8)"
    },
    "&.MuiCheckbox-colorSecondary": {
      "&.Mui-checked": {
        color: "rgba(160, 81, 201, 1)"
      }
    }
  }
}));

 function RecursiveTreeView(props) {
  const [selected, setSelected] = React.useState([]);

 
  useEffect(()=>{
    console.log("USEEFFECT"+JSON.stringify(props.selectedList));
      if(props.selectedList.length > 0)
          setSelected(props.selectedList);
      else 
          setSelected([]);
      //console.log(JSON.stringify(props.selectedList));
  },[props.selectedList]);
  
  useEffect(() => {
    //console.log("*****"+JSON.stringify(selected));
  },[selected])
  //node is always the root "Parent"
  //id is id of node clicked
  function getChildById(node, nodeId) {
    let array = [];

    //returns an array of nodes ids: clicked node id and all children node ids
    function getAllChild(nodes) {
      if (nodes === null) return [];
          array.push(nodes);
      //array.push(nodes.nodeId);
      if (Array.isArray(nodes.children)) {
        nodes.children.forEach((node) => {
          array = [...array, ...getAllChild(node)];
          array = array.filter((v, i) => array.indexOf(v) === i);
        });
      }
      
      return array;
    }

    //returns the node object that was selected
    function getNodeById(nodes, nodeId) {
      if (nodes.nodeId === nodeId) {
        return nodes;
      } else if (Array.isArray(nodes.children)) {
        let result = null;
        nodes.children.forEach((node) => {
          if (!!getNodeById(node, nodeId)) {
            result = getNodeById(node, nodeId);
          }
        });
        return result;
      }

      return null;
    }

    return getAllChild(getNodeById(node, nodeId));
  }

  function getOnChange(checked, nodes) {
    //gets all freshly selected or unselected nodes
    props.setIsChange(true);
    const allNode = getChildById(props.data, nodes.nodeId);
    //combines newly selected nodes with existing selection
    //or filters out newly deselected nodes from existing selection
    
    // let array = checked
    //   ? [...selected, ...allNode]

    //   : selected.filter((value) => !allNode.includes(value.nodeId));

      if(checked)
        allNode[0].mapped = true;
      else
        allNode[0].mapped = false;
      
      let array = checked
      ? [...props.selectedList, ...allNode]
      :  props.selectedList.filter((value) => allNode[0].nodeId !== value.nodeId);

      console.log("CHANGE"+JSON.stringify(array));
    
      props.setSelectedList(array);
    //setSelected(array);
  }


  const RenderTreeWithCheckboxes = (nodes) => {
    const classes = useStyles();
    useEffect(()=>{
      console.log("#"+JSON.stringify(nodes));
    },[]);
    return (
      
      <TreeItem
        key={nodes.nodeId}
        nodeId={nodes.nodeId}
        label={
          
          <FormControlLabel
            
            control={ 
               nodes.isLeafNode ? (
               <Checkbox
           
               checked={ props.selectedList.find(item => (item.nodeId === nodes.nodeId))}
               inputProps={{ 'aria-label': 'controlled' }}
              onChange={(event) =>
                getOnChange(event.currentTarget.checked, nodes)
              }
                
                // checked={selected.some((item) => (
                //   (item === nodes.nodeId) ))}
                // onChange={(event) =>
                //   getOnChange(event.currentTarget.checked, nodes)
                // }
                
                className={classes.checkbox}
              />):(<div></div>)
            }
            label={<>{nodes.name}</>}
            key={nodes.nodeId}
          />
        }
      >
        {/* {Array.isArray(nodes.children)
          ? nodes.children.map((node) => ("*"+JSON.stringify(node)))
          : null} */}
        {Array.isArray(nodes.children)
          ? nodes.children.map((node) => RenderTreeWithCheckboxes(node))
          : null}
      </TreeItem>
    );
  };

  return (
    <>
      <TreeView
        defaultCollapseIcon={<ExpandMoreIcon />}
        
        defaultExpandIcon={<ChevronRightIcon />}  
      >
        {props.data && RenderTreeWithCheckboxes(props.data,props.selectedList)}
      </TreeView>
      
      
    </>
  );
}

const CheckboxList = (props) => {
  // Sample JSON data (replace with your API response)
  /* const initialData = [
    { id: 1, name: 'Option 1', selected: true },
    { id: 2, name: 'Option 2', selected: false },
    { id: 3, name: 'Option 3', selected: true },
    { id: 4, name: 'Option 4', selected: false },
     { id: 5, name: 'Option 4', selected: false },
      { id: 6, name: 'Option 4', selected: false },
       { id: 7, name: 'Option 4', selected: false },
        { id:8, name: 'Option 4', selected: false },
         { id: 9, name: 'Option 4', selected: false },
          { id: 10, name: 'Option 4', selected: false }
  ]; */

  const [items, setItems] = useState( [] );

  useEffect(() => {
    // Transform props.data into the desired format
    if(props.data === null || props.data === undefined){
      setItems([]);
        return;
    }
      
      setItems(props.data);
      }, [props.data]);

  // Toggle checkbox
  const handleCheckboxChange = (id) => {
    props.setIsChange(true);
    
     props.setSelectedList(items.map(item => ({
        ...item,
        mapped: item.locId === id ? !item.mapped : item.mapped
      })));
      setItems(prevItems =>
      prevItems.map(item => ({
        ...item,
        mapped: item.locId === id ? !item.mapped : item.mapped
      })))
    

  };

  // Submit modified data
  const handleSubmit = () => {
    const modifiedData = items.map(item => ({
       promoId: item.promoId,
        locId: item.locId,
            locName: item.locName,
            mapped: item.mapped
    }));
    
    console.log('Submitting modified data:', modifiedData);
    // Send to API: axios.post('/api/save', modifiedData);
    
    alert('Submitted: ' + JSON.stringify(modifiedData, null, 2));
  };

  return (
    <Box sx={{ maxWidth: 400 }}>
      <Typography variant="h8" gutterBottom>
        Select Locations
      </Typography>
      
      <FormGroup>
        <List sx={{ p: 0, '& .MuiListItem-root': { py: 0.5 } }}> {/* Tight padding */}
  {items.map((item) => (
    <ListItem 
      key={item.locId} 
      disablePadding 
      divider={false}  // No dividers
      sx={{ '&:hover': { bgcolor: 'action.hover' } }} // Hover effect
    >
      <FormControlLabel
        sx={{ 
          m: 0,           // Remove default margin
          width: '100%',
          '& .MuiFormControlLabel-label': { fontSize: '0.875rem' } // Smaller text
        }}
        control={
          <Checkbox 
            size="small"    // Smaller checkbox
            checked={item.mapped}
            onChange={() => handleCheckboxChange(item.locId)}
            sx={{ p: 0.5, mr: 1 }} // Tight padding
          />
        }
        label={item.locName}
      />
    </ListItem>
  ))}
</List>

      </FormGroup>
      
      
    </Box>
  );
};

export default CheckboxList;
